import { z } from 'zod'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import trainingObject from '../training/trainingObject'

export const trainingPerformedObject = z.object({
  id: z.string().uuid(),
  citizenId: citizenObject.shape.id,
  trainingId: trainingObject.shape.id,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CitizenTrainedType = z.infer<typeof trainingPerformedObject>

export const propertyMap = {
  id: sql`citizen_trained.id`,
  citizenId: sql`citizen_trained.citizen_id`,
  trainingId: sql`citizen_trained.training_performed_id`,
  clientId: sql`citizen_trained.client_id`,
  insertUserId: sql`citizen_trained.insert_user_id`,
  editUserId: sql`citizen_trained.edit_user_id`,
  createdAt: sql`citizen_trained.created_at`,
  updatedAt: sql`citizen_trained.updated_at`,
  deletedAt: sql`citizen_trained.deleted_at`,
}

export default trainingPerformedObject
